import React from 'react';

const ViewHeader = (props) => {
  const { heading, description } = props.content;
  const { customOverrideClass, productError } = props;
  return (
    <div className="row">
      <div className={productError ? 'view-header col-12' : 'view-header col-12 pl-sm-0'}>
        <h1 id="main-heading" className={customOverrideClass ? `${customOverrideClass}` : 'heading'}>{heading}</h1>
        <p id="main-description" className="description">{description}</p>
      </div>
    </div>
  );
};

export default ViewHeader;
